<template>
  <b-modal ref="addTaskModal" id="addTaskModal" hide-footer title="Add Task">
    <b-form @submit="submitForm">
      <b-row>
        <b-col>
          <b-form-group id="title" label="* Title" label-for="title">
            <b-form-input
              id="title"
              v-model="task.title"
              required
              placeholder="Defines Value of Task"
              type="text"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12" md="3">
          <label for="due">Due Date:</label>
        </b-col>
        <b-col sm="12" md="9">
          <b-form-input id="due" v-model="task.dueDate" type="date"></b-form-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col xl="12">
          <label for="description">Description:</label>
        </b-col>
      </b-row>

      <b-row>
        <b-col xl="12">
          <b-form-textarea
            id="description"
            v-model="task.description"
            placeholder="Reson for task request NOT how to implement it!"
            rows="4"
            max-rows="6"
          ></b-form-textarea>
        </b-col>
      </b-row>

      <b-button variant="outline-primary" type="submit">
        <b-icon-archive-fill></b-icon-archive-fill>Save
      </b-button>
    </b-form>
  </b-modal>
</template>
  <script>
export default {
  name: "NewTaskModal",
  data() {
    return {
      task: {}
    };
  },
  methods: {
    submitForm() {
      this.$emit('addTask', this.task);
    }
  }
};
</script>